module.exports = __webpack_public_path__ + "34736292/img/document.e2130c6b.svg";